import styled from 'styled-components';

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 8px;
`;
export default LabelContainer;
